if (!customElements.get('card-slider')) {
  class CardSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

      this.initSlider(swiperOptions);

      if (this.classList.contains('js-testimonials')) {
        window.addEventListener('resize', () => {
          const isMobile = window.innerWidth < mobileWidth;
          const isSlideEffect = this.slider.params.effect === 'slide';

          if ((isMobile && !isSlideEffect) || (!isMobile && isSlideEffect)) {
            this.reInitSlider(swiperOptions);
          }
        });
      }
    }

    reInitSlider(swiperOptions) {
      this.slider.destroy();
      this.initSlider(swiperOptions);
    }

    initSlider(swiperOptions) {
      let sliderOptions = {
        effect: 'fade', // Apply fade effect
        slidesPerView: 1, // Show 1 slide per view on both desktop and mobile
        spaceBetween: swiperOptions.spaceBetweenMobile || 2,
        resistanceRatio: 0.72,
        autoplay: {
          delay: 3000, // Change slide every 3 seconds
          disableOnInteraction: false, // Autoplay continues after user interaction
        },
        pagination: {
          el: '.swiper-pagination', // Target pagination element
          clickable: true, // Make dots clickable
          renderBullet: function (index, className) {
            return `<span class="${className}"></span>`; // Customize dot appearance
          },
        },
        loop: true, // Enable infinite loop
        breakpoints: {
          750: {
            slidesPerView: 1, // Keep 1 slide per view on desktop
            spaceBetween: swiperOptions.spaceBetweenDesktop || 2,
          }
        }
      };

      const isArticlesSlider = this.classList.contains('js-articles');

      if (isArticlesSlider) {
        sliderOptions.breakpoints[575] = {
          slidesPerView: 1, // Ensure 1 slide per view on smaller screens
        };
      } else if (this.classList.contains('js-testimonials')) {
        if (window.innerWidth < mobileWidth) {
          sliderOptions.spaceBetween = 4;
        }
      }

      this.slider = new Swiper(this, sliderOptions);
    }
  }

  customElements.define('card-slider', CardSlider);
}
